import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
import LanguageIcon from '@mui/icons-material/Language';
import { styled } from '@mui/material/styles';
import { Translate, translateDateFormat } from '../../../../../../../shared/LanguageService';
import { CommentTime } from '../../imagePreview/queries/use-query-edited-image';

const Timestamp = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    whiteSpace: 'nowrap',
    fontSize: '13px',
    color: '#555'
});

type CommentTimestampProps = {
    time: CommentTime;
};

export function CommentTimestamp({ time }: CommentTimestampProps) {
    let localText = translateDateFormat(new Date(time.localDateTime), 'P p');
    let hasOtherOriginalTime =
        Boolean(time.originalDateTime) && time.originalDateTime !== time.localDateTime;

    return (
        <Timestamp>
            {localText}
            {hasOtherOriginalTime && (
                <Tooltip
                    title={`${Translate('date-time-view/orignal-timezone')}: ${translateDateFormat(
                        new Date(time.originalDateTime),
                        'P p'
                    )}`}
                >
                    <LanguageIcon sx={{ fontSize: 18 }} data-testid="comment-original-time" />
                </Tooltip>
            )}
        </Timestamp>
    );
}
